import { processingSessionItemIdFormat } from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const evaluateSpecForItem = {
  name: "evaluateSpecForItem" as const,
  input: z.object({
    sessionItemId: processingSessionItemIdFormat.schema,
    returnId: zExt.objectId(),
    returnItemId: zExt.objectId(),
    photoUrls: z.array(z.string()),
    productDescription: z.string().optional(),
  }),
  output: z.object({
    disposition: z.string().nullable(),
    matchedConditions: z.array(z.string()),
    reasoning: z.string(),
  }),
};
